<template>
  <div v-loading="showFlag">
    <t-card class="card_common">
      <!-- ボタン -->
      <div>
        <t-row>
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FIVE'))"
            class="col_common_center"
          >
            <!-- 新規 -->
            <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
            <!-- 品質保証部の権限を追加する -->
            <!-- <t-button
              round
              type="primary"
              class="button_common"
              ref="addBtn"
              @click="addClick()"
            > -->
            <t-button
              round
              type="primary"
              class="button_common"
              ref="addBtn"
              @click="addClick()"
              :disabled="isDLUserLocal"
            >
              <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->

              <i class="el-icon-plus"></i>
              {{ $t("resource.COMMON_CONSTANT.ADD") }}
            </t-button></t-col
          >
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FIVE'))"
            class="col_common_center"
          >
            <!-- 一括手配 -->
            <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
            <!-- 品質保証部の権限を追加する -->
            <!-- <t-button
              round
              type="primary"
              class="button_common"
              ref="addAllOrderInfo"
              @click="addAllOrderInfo()"
            > -->
            <t-button
              round
              type="primary"
              class="button_common"
              ref="addAllOrderInfo"
              @click="addAllOrderInfo()"
              :disabled="isDLUserLocal"
            >
              <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->

              <i class="el-icon-plus"></i>
              {{ $t("resource.COMMON_CONSTANT.ADD_ALL_ORDER") }}
            </t-button></t-col
          >
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FIVE'))"
            class="col_common_center"
          >
            <!-- 削除 -->
            <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
            <!-- 品質保証部の権限を追加する -->
            <!-- <t-button
              round
              type="danger"
              class="button_common"
              ref="delBtn"
              @click="deleteClickSelected"
            > -->
            <t-button
              round
              type="danger"
              class="button_common"
              ref="delBtn"
              @click="deleteClickSelected"
              :disabled="isDLUserLocal"
            >
              <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->

              <i class="el-icon-delete"></i>
              {{ $t("resource.COMMON_CONSTANT.DELETE") }}
            </t-button></t-col
          >

          <!-- 配送単出力 -->
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FIVE'))"
            class="col_common_center"
          >
            <t-button
              round
              type="primary"
              class="button_common"
              ref="outPutDeliveryBtn"
              @click="outPutDeliveryClick"
              :disabled="false"
            >
              <i class="el-icon-download"></i>
              {{ $t("resource.ORDER.OUTPUT_DELIVERY_ORDER") }}
            </t-button>
          </t-col>

          <!-- 出力 -->
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
            class="col_common_center"
          >
            <t-button
              round
              type="primary"
              class="button_common"
              ref="outPutBtn"
              @click="outPutClick"
              :disabled="false"
            >
              <i class="el-icon-download"></i>
              {{ $t("resource.ORDER.OUTPUT_ORDER") }}
            </t-button>
          </t-col>
        </t-row>

        <!-- 検索条件 -->
        <div class="div_common_search">
          <t-divider>{{
            $t("resource.COMMON_CONSTANT.SEARCH_CONDITION")
          }}</t-divider>
          <div class="search">
            <t-form
              :model="searchConditionForm"
              :label-width="$t('widgetSize.search.labelWidth')"
            >
              <t-row>
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                  >&nbsp;</t-col
                >

                <!-- 手配日/仕入先納期 -->
                <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
                <!-- 目的港の追加 -->
                <!-- <t-col :span="11"> -->
                <t-col :span="9">
                  <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->
                  <div>
                    <t-form-item class="dateLabelWidth" label-width="180px">
                      <span slot="label">
                        <div style="margin-top: 1px">
                          <t-radio-group
                            v-model="orderDateLabel"
                            size="small"
                            style="margin-right: 5px"
                            @change="handleDateChange"
                          >
                            <t-radio-button label="1">{{
                              $t("resource.ORDER.ORDER_DATE")
                            }}</t-radio-button>
                            <t-radio-button label="2">{{
                              $t("resource.ORDER.DELIVERY_DATE")
                            }}</t-radio-button>
                          </t-radio-group>
                        </div>
                      </span>

                      <!-- UPD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓ -->
                      <!-- クリア可能 -->
                      <!-- <t-date-picker
                        v-model="dateRange"
                        type="daterange"
                        style="min-width: 20px; width: 75%; margin-left: -12px"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy-MM-dd"
                        class="date_icon_center"
                        :clearable="false"
                        :editable="false"
                        format="yyyy/MM/dd"
                      >
                      </t-date-picker>-->

                      <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
                      <!-- 目的港の追加 -->
                      <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->
                      <!-- <t-date-picker
                        v-model="dateRange"
                        type="daterange"
                        style="min-width: 20px; width: 75%; margin-left: -12px"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy-MM-dd"
                        class="date_icon_center"
                        :clearable="true"
                        :editable="false"
                        format="yyyy/MM/dd"
                      > -->

                      <t-date-picker
                        v-model="dateRange"
                        type="daterange"
                        style="min-width: 20px; width: 90%; margin-left: -12px"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy-MM-dd"
                        class="date_icon_center"
                        :clearable="true"
                        :editable="false"
                        format="yyyy/MM/dd"
                      >
                      <!-- UPD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑ -->
                      </t-date-picker>
                    </t-form-item>
                  </div>
                </t-col>

                <!-- ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- 検索条件：「得意先納期」の追加 -->
                 <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
                <!-- 目的港の追加 -->
                <!-- <t-col :span="8" class="right"> -->
                <!-- <div>
                <t-form-item
                  :label="
                    $t('resource.ACCEPT_ORDER.CUSTOMER_DELIVERY_DATE')
                  "
                  label-width="$t('widgetSize.COMMON_WIDTH.NINETY_PX')"
                > -->
                <!-- 得意先納期(開始日～終了日) -->
                      <!-- <t-date-picker
                        v-model="dateCusRange"
                        type="daterange"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy-MM-dd"
                        class="date_icon_center"
                        :clearable="true"
                        style="min-width: 20px; width: 75%; margin-left: -3px"
                        format="yyyy/MM/dd"
                        :editable="false"
                      > -->
                  <t-col :span="7" class="left">
                    <div>
                    <t-form-item
                      :label="
                        $t('resource.ACCEPT_ORDER.CUSTOMER_DELIVERY_DATE')
                      "
                      label-width="$t('widgetSize.COMMON_WIDTH.EIGHTY_PX')"
                       class="inline-form-item"

                    >
                       <t-date-picker
                        v-model="dateCusRange"
                        type="daterange"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy-MM-dd"
                        class="date_icon_center"
                        :clearable="true"
                        style="min-width: 20px; width: 100%;"
                        format="yyyy/MM/dd"
                        :editable="false"
                      >
                       <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->
                      </t-date-picker>
                    </t-form-item>
                  </div>
                </t-col>

                <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
                <!-- <t-col :span="1">&nbsp;</t-col> -->
                <!-- 目的港の追加 -->
                <t-col
                  :span="4"
                >
                  <t-form-item :label="$t('resource.ORDER.STATUS')"
                  :label-width="$t('widgetSize.COMMON_WIDTH.SIXTY_PX')">
                    <t-select
                      v-model="searchConditionForm.searchStatus"
                      clearable
                      style="width: 100%"
                      :placeholder="$t('resource.COMMON_CONSTANT.HIDDEN')"
                    >
                      <t-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->

                <!-- 再入荷 -->
                <t-col :span="2"
                  class="col_common_center">
                  <template>
                    <t-checkbox
                      v-model="searchConditionForm.searchRestock"
                      :label="$t('resource.ORDER.RESTOCK')"
                      style="line-height: 3"
                    />
                  </template>
                </t-col>
                <!-- ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->

                <!-- DEL 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- 再入荷 -->
                <!-- <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWO'))"
                  class="col_common_center"
                >
                  <t-checkbox
                    v-model="searchConditionForm.searchRestock"
                    style="line-height: 3"
                    >{{ $t("resource.ORDER.RESTOCK") }}</t-checkbox
                  >
                </t-col> -->
                <!-- DEL 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
              </t-row>

              <t-row>
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                  class="col_common_left"
                  >&nbsp;</t-col
                >
                <!-- 検索キー -->
                <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
                <!-- 手配一覧画面の検索条件の追加（入荷状態） -->
                <!-- <t-col :span="13" class="col_block_left"> -->
                <t-col :span="9" class="col_block_left">
                  <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->
                  <t-form-item
                    :label="$t('resource.COMMON_CONSTANT.SEARCH_KEY')"
                  >
                   <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
                    <!-- <t-input
                      v-model="searchConditionForm.searchWord"
                      class="input_searchKey"
                      maxlength="50"
                      clearable
                    > -->
                     <t-input
                      v-model="searchConditionForm.searchWord"
                      class="input_searchKey"
                      maxlength="50"
                      style="width: 90%;"
                      clearable
                    >
                     <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->
                    </t-input>
                  </t-form-item>
                </t-col>

               <!-- ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
                 <!-- 目的港の追加 -->
                 <t-col
                  :span="6"
                >
                <t-form-item :label="$t('resource.ORDER.DESTINATION_PORT')">
                    <t-select
                      v-model="searchConditionForm.searchDestPortCode"
                      clearable
                      style="width: 100%"
                      :placeholder="$t('resource.COMMON_CONSTANT.HIDDEN')"
                    >
                      <t-option
                        v-for="item in destinationList"
                        :key="item.dpCode"
                        :label="item.dpName"
                        :value="item.dpCode"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <!-- ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->

                <t-col
                  :span="1"
                  class="col_common_left"
                  >&nbsp;</t-col
                >

                <!-- ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
                 <!-- 手配一覧画面の検索条件の追加（入荷状態） -->
                 <t-col
                  :span="4"
                >
                  <t-form-item :label="$t('resource.ORDER.RCV_STATUS')" :label-width="$t('widgetSize.COMMON_WIDTH.SIXTY_PX')">
                    <template slot="label">
                    <span style="margin-left: -10px; display: inline-block;">
                      入荷状态
                    </span>
                    </template>
                    <t-select
                      v-model="searchConditionForm.searchRcvStatus"
                      clearable
                      style="width: 100%"
                      :placeholder="$t('resource.COMMON_CONSTANT.HIDDEN')"
                    >
                      <t-option
                        v-for="item in rcvStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <!-- ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->

                <!-- 状態 -->
                  <!-- DEL 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
                <!-- <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FIVE'))"
                >
                  <t-form-item :label="$t('resource.ORDER.STATUS')">
                    <t-select
                      v-model="searchConditionForm.searchStatus"
                      clearable
                      style="width: 100%"
                      :placeholder="$t('resource.COMMON_CONSTANT.HIDDEN')"
                    >
                      <t-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>-->

                <!-- <t-col :span="1">&nbsp;</t-col> -->
                <!-- DEL 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->
                <!-- 検索 -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWO'))"
                  class="col_common_left"
                >

                <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
                <!-- 目的港の追加 -->
                  <!-- <t-button
                    round
                    type="primary"
                    class="button_common_search marginRight"
                    ref="searchBtn"
                    @click="searchClick()"
                  > -->
                   <t-button
                    round
                    type="primary"
                    class="button_common_search"
                    ref="searchBtn"
                    style="margin-left: 15px;"
                    @click="searchClick()"
                  >
                <!-- UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->

                    <i class="el-icon-search"></i
                    >{{ $t("resource.COMMON_CONSTANT.SEARCH") }}
                  </t-button>
                </t-col>
              </t-row>
            </t-form>
          </div>
        </div>
      </div>

      <!-- 検索結果一覧 -->
      <div class="div_content">
        <t-table
          ref="orderTableData"
          :data="tableData"
          class="table_common"
          header-cell-class-name="bg-default"
          @row-dblclick="detailClick"
          :height="maxheight"
          border
        >
          <t-table-column type="selection" class-name="cell_txt_center" />

          <!-- 状態 -->
          <t-table-column
            prop="obStatusVal"
            :label="$t('resource.ORDER.STATUS')"
            :min-width="
              flexColumnWidthFunc($t('resource.ORDER.STATUS'), 'obStatusVal')
            "
            class-name="cell_txt_center"
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span :class="formatStatusColor(row)" class="status">●</span>
                <span class="order-status">{{ row.obStatusVal }} </span>
              </div>
            </template>
          </t-table-column>

          <!-- 再入荷 -->
          <t-table-column
            prop="nbOrderState"
            :label="$t('resource.ORDER.RESTOCK')"
            class-name="cell_txt_center"
            :min-width="
              flexColumnWidthFunc($t('resource.ORDER.RESTOCK'), 'obProdExKbn')
            "
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span
                  v-if="row.obRestockKbn === restockFlg"
                  class="status orderCheck"
                  >●</span
                >
              </div>
            </template>
          </t-table-column>

          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          >
          </t-table-column>
        </t-table>

        <!-- 改ページ -->
        <t-pagination
          align="right"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          :page-sizes="getPageDataCountFunc()"
          layout="total, sizes, prev, pager, next"
          :total="orderTableDatalength"
          @current-change="pageChange"
          @size-change="handleSizeChange"
        >
        </t-pagination>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import {
  ShowAddAllOrderInfoDialog,
  ShowMisumiSelectDialog,
  ShowOrderEditDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import { outputExcelToZip } from "@/services/common";
import {
  deleteOrderBasicByOrderNo,
  initOrderSearchList,
  searchOrderBasic,
} from "@/services/order";
import {
  formatDateStrToString,
  formatDateToString,
  formatStringToCurrency,
  getAbleDestinationList,
  getNextMonthDate,
  getPreviousMonthDate,
} from "@/utils/comFunction";
import {
  GetPageDataCount,
  STR_HYPHEN,
  STR_ONE,
  STR_ZERO
} from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //日付検索範囲
      dateRange: [],
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 検索条件：「得意先納期」の追加
      dateCusRange: [],
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

      //検索条件
      searchConditionForm: {
        searchStartDate: "",
        searchEndDate: "",
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
        // 検索条件：「得意先納期」の追加
        searchCusStartDate: "",
        searchCusEndDate: "",
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
        isOrderDate: true,
        searchStatus: "",
        searchRestock: false,
        searchWord: "",
        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
        // 手配一覧画面の検索条件の追加（入荷状態）; 目的港の追加
        // 入荷状態
        searchRcvStatus: "",
        // 目的港
        searchDestPortCode: "",
        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
      },

      // UPD 2025/3/28 Wjx 課題_250328顧客からの改善したい点への対応 start↓
      //デフォルトの時間検索条件は「手配日」⇒「仕入先納期」に変更
      //orderDateLabel: "1",
      //デフォルト：仕入先納期
      orderDateLabel: "2",
      // UPD 2025/3/28 Wjx 課題_250328顧客からの改善したい点への対応 end↑

      //一覧データ
      orderTableData: [],

      //状態
      statusList: [],

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 手配一覧画面の検索条件の追加（入荷状態）；目的港の追加
      // 入荷状態リスト
      rcvStatusList: [],
      // 目的港リスト
      destinationList: [],
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

      columns: [
        // 注文No
        {
          prop: "obOrderNoShow",
          label: t("resource.COMMON_CONSTANT.ORDER_NO"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // UPD 2025/3/28 Wjx 課題_250328顧客からの改善したい点への対応 start↓
        // 一覧表に「手配日」と「仕入先納期」の位置変換
        // // 手配日
        // {
        //   prop: "obDate",
        //   label: t("resource.ORDER.ORDER_DATE"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_center",
        // },

        // 得意先納期
        {
          prop: "aobCusDeliveryDate",
          label: t("resource.ORDER.CUSTOMER_DELIVERY_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // 仕入先納期
        {
          prop: "obDueDate",
          label: t("resource.ORDER.DELIVERY_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // UPD 2025/3/28 Wjx 課題_250328顧客からの改善したい点への対応 end↑

        // 仕入先
        {
          prop: "obSupCode",
          label: t("resource.COMMON_CONSTANT.SUPPLIER"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // プロセス区分
        {
          prop: "obProcKbn",
          label: t("resource.ORDER.PROC_KBN"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
        },
        // 連絡担当者
        {
          prop: "obUserName",
          label: t("resource.COMMON_CONSTANT.CONNECTER"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // 見積ターブル
        {
          prop: "obQuoteType",
          label: t("resource.ORDER.QUOTE_TYPE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        // UPD 2025/3/28 Wjx 課題_250328顧客からの改善したい点への対応 start↓
        // 一覧表に「手配日」と「仕入先納期」の位置変換
        // // 仕入先納期
        // {
        //   prop: "obDueDate",
        //   label: t("resource.ORDER.DELIVERY_DATE"),
        //   width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_center",
        // },

        // 手配日
        {
          prop: "obDate",
          label: t("resource.ORDER.ORDER_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // UPD 2025/3/28 Wjx 課題_250328顧客からの改善したい点への対応 end↑

        // 輸送方式
        {
          prop: "obTransMethod",
          label: t("resource.ORDER.TRANS_METHOD"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
        },

        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
        // 目的港の追加
        // 目的港
        {
          prop: "obDpName",
          label: t("resource.ORDER.DESTINATION_PORT"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
        },

        // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

        // 金額(CNY)
        {
          prop: "obSumPrice",
          label: t("resource.ORDER.AMOUNT"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 注文件数
        {
          prop: "obSumQty",
          label: t("resource.ORDER.ORDER_COUNT"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 検査室入荷件数
        {
          prop: "obSumCheckOkQty",
          label: t("resource.ORDER.INSPECTRCV_COUNT"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 運送件数
        {
          prop: "obSumTransQty",
          label: t("resource.ORDER.TRANSPORT_COUNT"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 日本入荷件数
        {
          prop: "obSumReceOkQty",
          label: t("resource.ORDER.OFFICERCV_COUNT"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 支払状態
        {
          prop: "obPayStatus",
          label: t("resource.ORDER.PAYMENT_STATUS"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
      ],

      // 再入荷
      restockFlg: "1",
      //待ちダイアログ
      showFlag: false,

      // 現在のページ数
      pageNo: 1,
      // データ個数/各ページ
      pageSize: 20,
      // データ総数
      orderTableDatalength: 0,
      maxheight: window.innerHeight - 291.5 - 10, //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6

      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      // 得意先納期の列幅フラグ（true:増加）
      cusDeliveryDateChangeWidth: false,
      // 仕入先納期の列幅フラグ（true:増加）
      supDueDateChangeWidth: false,
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 品質保証部の権限を追加する
      isDLUserLocal: false,
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
    };
  },

  computed: {
    tableData() {
      return this.orderTableData.slice(
        (this.pageNo - 1) * this.pageSize,
        this.pageNo * this.pageSize
      );
    },
  },

  mounted() {
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 品質保証部の権限を追加する
    this.isDLUserLocal = sessionStorage.getItem("isDLUser") === "true";
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

    //画面初期化
    this.init();
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    setColumnWidth(this.columns, this.orderTableData);
    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 納期、注番の変更(見積単位⇒製品単位に変更)
    // 列幅の調整
    this.columns = this.columns.map((col) => {
      if (col.prop === "aobCusDeliveryDate") {
        return { ...col, width: this.cusDeliveryDateChangeWidth ? 200 : 100 };
      }
      if (col.prop === "obDueDate") {
        return { ...col, width: this.supDueDateChangeWidth ? 200 : 100 };
      }
      return col;
    });
    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
  },

  methods: {
    // 「新規」ボタン
    addClick() {
      ShowOrderEditDialog(
        {
          isAdd: true,
        },
        t("resource.ORDER.ORDEREDIT_DIALOG"),
        this.searchClick
      );

      // フォーカス削除
      this.$refs.addBtn.$el.blur();
    },

    // 一括手配
    addAllOrderInfo() {
      ShowAddAllOrderInfoDialog(
        {
          isAdd: true,
        },
        t("resource.COMMON_CONSTANT.ADD_ALL_ORDER"),
        this.searchClick
      );

      // フォーカス削除
      this.$refs.addAllOrderInfo.$el.blur();
    },

    //データの処理
    dataProcess() {
      this.orderTableData.map((item) => {
        //注文日の変換
        item.obDate = formatDateStrToString(item.obDate);

        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // //仕入先納期
        // item.obDueDate = formatDateStrToString(item.obDueDate);
        // 最小仕入先納期と最大仕入先納期
        var stringSupDueDateMin = formatDateStrToString(item.obDueDateMin);
        var stringSupDueDateMax = formatDateStrToString(item.obDueDateMax);
        //仕入先納期の変換
        if (stringSupDueDateMin == stringSupDueDateMax) {
          item.obDueDate = stringSupDueDateMin;
        } else {
          //仕入先納期の列幅フラグ（true:増加）
          this.supDueDateChangeWidth = true;
          item.obDueDate = stringSupDueDateMin + "～" + stringSupDueDateMax;
        }
        // 最小得意先納期と最大得意先納期
        var stringCusDeliveryDateMin = formatDateStrToString(
          item.aobCusDeliveryDateMin
        );
        var stringCusDeliveryDateMax = formatDateStrToString(
          item.aobCusDeliveryDateMax
        );
        //得意先納期の変換
        if (stringCusDeliveryDateMin == stringCusDeliveryDateMax) {
          item.aobCusDeliveryDate = stringCusDeliveryDateMin;
        } else {
          //得意先納期の列幅フラグ（true:増加）
          this.cusDeliveryDateChangeWidth = true;
          item.aobCusDeliveryDate =
            stringCusDeliveryDateMin + "～" + stringCusDeliveryDateMax;
        }

        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        //金額
        item.obSumPrice = formatStringToCurrency(item.obSumPrice);

        return item;
      });
    },

    //日付初期化
    // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    //dateInit() {
    dateInit(orderDateLabel) {
      // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
      //システム日付
      var systemDate = new Date();

      // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 日付初期値の設定
      //this.dateRange = [getPreviousMonthDate(systemDate), systemDate];
      this.dateRange =
        orderDateLabel != "1"
          ? [systemDate, getNextMonthDate(systemDate)] //仕入先納期の場合、現在から今後1か月の期間
          : [getPreviousMonthDate(systemDate), systemDate]; //手配日の場合、過去1ヶ月から現在までの期間
      // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
    },

    //複数行データの削除
    deleteClickSelected() {
      let data = this.$refs.orderTableData.selection;

      // console.log(data);

      var deleteFlg = true;

      if (data.length >= 1) {
        let delList = [];

        // 「新規、注文中」以外のデータの削除が不可
        for (let index = 0; index < data.length; index++) {
          // let dataStatus = data[index].obStatusVal;

          //"新規"、"注文中"以外データは削除不可
          // if (
          //   this.statusList[0].label != dataStatus &&
          //   this.statusList[1].label != dataStatus
          // ) {
          //   deleteFlg = false;
          //   Message.showError(t("message.ORDER.NOT_DELETE"));
          //   break;
          // }

          //入荷済み件数がある場合、削除不可
          if (
            data[index].obSumCheckOkQty != 0 ||
            data[index].obSumReceOkQty != 0
          ) {
            deleteFlg = false;
            Modal.showError("", t("message.ORDER.NOT_DELETE_RECE"), {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            break;
          }
          //支払した手配データのチェック
          if (data[index].payFlg !== STR_ZERO) {
            deleteFlg = false;
            Modal.showError("", t("message.ORDER.NOT_DELETE_PAY"), {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            break;
          }

          // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓

          //発送予定した手配データのチェック
          if (data[index].obPrepTransKbn !== STR_ZERO) {
            deleteFlg = false;
            Modal.showError("", t("message.ORDER.NOT_DELETE_PREP_TRANS"), {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            break;
          }
          // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

          delList.push(data[index].obOrderNo);
        }

        //削除可能の場合
        if (deleteFlg) {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DELETE_CONFIRM_MSG"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
              cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
              showCancelButton: true,
            }
          ).then(() => {
            deleteOrderBasicByOrderNo(delList)
              .then(() => {
                //削除成功
                Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));

                //検索処理を行う
                this.searchClick();
              })
              .catch((err) => {
                this.showFlag = false;
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
                }
              });
          });
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      // フォーカス削除
      this.$refs.delBtn.$el.blur();
    },

    //編集処理
    detailClick(row) {
      ShowOrderEditDialog(
        {
          isAdd: false,
          rowData: row,
        },
        t("resource.ORDER.ORDEREDIT_DIALOG"),
        this.searchClick
      );
    },

    //アダプティブ列幅
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.orderTableData);
    },

    //状態の色の設定
    formatStatusColor(row) {
      return row.obStatusColor;
    },

    //毎ページ件数の取得
    getPageDataCountFunc() {
      // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 手配一覧画面の一覧表のページネーションの最大数量の追加
      // return GetPageDataCount();
      const original = GetPageDataCount();
      // 1ページに1000個:を追加する
      return [...original, 1000];
      // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
    },

    //テーブルの高さを設定する
    handleResize() {
      this.maxheight = window.innerHeight - 291.5 - 10; //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    },

    //毎ページ件数の設定
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
    },

    // 画面初期化
    init() {
      this.showFlag = true;

      //検索条件リストの初期化(状態、支払状態)
      initOrderSearchList()
        .then((res) => {
          //状態
          this.statusList = res.searchStatus;

          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
          // 手配一覧画面の検索条件の追加（入荷状態）
          // 入荷状態リスト
          this.rcvStatusList = res.searchRcvStatus;

          // 目的港の追加
          // 目的港リスト
          this.destinationList = getAbleDestinationList(
            res.destinationPortList,
            ""
          );
          // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

          // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          //日付初期化
          //this.dateInit();
          this.dateInit(this.orderDateLabel);
          // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

          //検索処理
          this.searchClick();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
          this.showFlag = false;
        });
    },

    //「出力」ボタン
    outPutClick() {
      this.showFlag = true;
      //検索条件の処理
      this.updateSearchForm();
      //注文台帳情報出力
      outputExcelToZip(
        httpApi.OutPutOrderLedgerInfo,
        this.searchConditionForm
      ).finally(() => {
        this.showFlag = false;
        // フォーカス削除
        this.$refs.outPutBtn.$el.blur();
      });
    },

    //ページング処理
    pageChange(val) {
      this.pageNo = val;
    },

    // 「検索」ボタン
    searchClick() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      //検索条件の処理
      this.updateSearchForm();

      //検索注文基本情報
      searchOrderBasic(this.searchConditionForm)
        .then((res) => {
          //一覧データ
          this.orderTableData = res;
          //一覧データの総件数
          this.orderTableDatalength = res.length;

          // データ処理
          this.dataProcess();

          setColumnWidth(this.columns, this.orderTableData);
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          // 列幅の調整
          this.columns = this.columns.map((col) => {
            if (col.prop === "aobCusDeliveryDate") {
              return {
                ...col,
                width: this.cusDeliveryDateChangeWidth ? 200 : 100,
              };
            }
            if (col.prop === "obDueDate") {
              return { ...col, width: this.supDueDateChangeWidth ? 200 : 100 };
            }
            return col;
          });
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });

      if (typeof this.$refs.searchBtn !== "undefined") {
        // フォーカス削除
        this.$refs.searchBtn.$el.blur();
      }
    },

    //テーブルのソート
    tableSort(column) {
      //ソート後、最初のページに戻る
      this.pageNo = 1;
      masterService.tableSort(this.orderTableData, column);
    },

    //検索条件の調整
    updateSearchForm() {
      //スペースを削除
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord.trim();

      //日付チェック区分の設定
      this.searchConditionForm.isOrderDate =
        this.orderDateLabel === "1" ? true : false;

      //日付の設定
      if (this.dateRange) {
        this.searchConditionForm.searchStartDate = formatDateToString(
          this.dateRange[0]
        );
        this.searchConditionForm.searchEndDate = formatDateToString(
          this.dateRange[1]
        );
      } else {
        this.searchConditionForm.searchStartDate = "";
        this.searchConditionForm.searchEndDate = "";
      }

      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 検索条件：「得意先納期」の追加
      if (this.dateCusRange) {
        this.searchConditionForm.searchCusStartDate = formatDateToString(
          this.dateCusRange[0]
        );
        this.searchConditionForm.searchCusEndDate = formatDateToString(
          this.dateCusRange[1]
        );
      } else {
        this.searchConditionForm.searchCusStartDate = "";
        this.searchConditionForm.searchCusEndDate = "";
      }
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
    },

    // 配送単出力
    outPutDeliveryClick() {
      let data = this.$refs.orderTableData.selection;

      if (typeof this.$refs.outPutDeliveryBtn !== "undefined") {
        // フォーカス削除
        this.$refs.outPutDeliveryBtn.$el.blur();
      }

      if (data.length >= 1) {
        let delList = [];

        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // 金額調整の手配データをチェック
        const obSuppQuoteType = data.every(
          (item) => item.obQuoteType === STR_HYPHEN
        );

        if (!obSuppQuoteType) {
          Modal.showWarning("", t("message.ORDER.SUPP_TYPE_MESSAGE"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return false;
        }

        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        const firstCategory = data[0].obSupCode;

        const obSupCodeAllSame = data.every(
          (item) => item.obSupCode === firstCategory
        );

        if (!obSupCodeAllSame) {
          Modal.showWarning("", t("message.CUS_PAY.SELECT_CUS_CODE_CHECK"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return false;
        }

        // DEL 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 start↓
        // const factoryKbnAllSame = data.every(
        //   (item) => item.supFactoryKbn === FACTORY_KBN_DALIAN
        // );

        // if (!factoryKbnAllSame) {
        //   Modal.showWarning("", t("message.ORDER.DL_MESSAGE"), {
        //     confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //   });
        //   return false;
        // }
        // DEL 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 end↑

        data.forEach((item) => delList.push(item.obOrderNo));

        // ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 start↓
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // ミスミ仕入先のチェック　⇒　関連仕入先区分のチェック
        // // ミスミ仕入先の場合
        // if (data[0].obSupCode.includes(STR_MISUMI)) {
        // 「1：関連仕入先」の場合
        if (data[0].supRelateFlag === STR_ONE) {
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          ShowMisumiSelectDialog(
            { isAdd: true, dataList: delList },
            t("resource.ORDER.MISUMI_KBN_SELECT"),
            this.searchClick
          );
        } else {
          let outputData = {
            misumiKbn: STR_ZERO,
            outPutList: delList,
          };
          // ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 end↑

          this.showFlag = true;

          // UPD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 start↓
          //配送単出力
          // outputExcelToZip(httpApi.OutPutDeliveryOrder, delList).finally(() => {
          outputExcelToZip(httpApi.OutPutDeliveryOrder, outputData).finally(
            () => {
              // UPD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 end↑
              this.showFlag = false;
              // フォーカス削除
              this.$refs.outPutDeliveryBtn.$el.blur();
            }
          );
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    //日付の変更イベント
    handleDateChange(val) {
      this.dateInit(val);
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
  },
};
</script>
<style lang="scss" scope>
.order-status {
  flex: 1; /* 使第二个 span 元素占据剩余空间，实现内容对齐 */
}

// ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
// 目的港の追加
.inline-form-item {
  display: flex;
  align-items: center;
  width: 100%;
}

.inline-form-item .el-form-item__label {
  width: 80px !important;
  flex-shrink: 0;
  white-space: nowrap;
}

.inline-form-item .el-form-item__content {
  flex: 1;
  margin-left: 0 !important;
}
// ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

</style>
